// extracted by mini-css-extract-plugin
export default {"column":"RecoveryCode_column__MupSj","buttonWrapper":"RecoveryCode_buttonWrapper__vbmYs"};